// extracted by mini-css-extract-plugin
export default {"aIPanelContent":"AIPanelContent__aIPanelContent___PWhOe"};